module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_9005.16f6ae9a.png";